var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHomeBundle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.755,
    height: 31.653,
    viewBox: "0 0 44.755 31.653",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j409hkrxka",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "kqy93bt0rb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 189",
    style: {
      fill: "url(#j409hkrxka)"
    },
    d: "M0 0h36.488v28.422H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2479"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3287",
    d: "M7 0h30.755a7 7 0 0 1 7 7v1a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7z",
    style: {
      fill: "#fff4aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1936"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 273",
    style: {
      clipPath: "url(#kqy93bt0rb)"
    },
    transform: "translate(4 3.231)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 151",
    d: "M17.666 28.422H4.111A4.116 4.116 0 0 1 0 24.311v-20.2A4.116 4.116 0 0 1 4.112 0H18c5.516 0 10.084 0 14.377.006a3.865 3.865 0 0 1 3.482 1.965 5.426 5.426 0 0 1 .452 1.057c.056.161.114.327.177.489V24.9a.569.569 0 0 0-.065.158 4.125 4.125 0 0 1-4.152 3.364h-14.6M2.494 12.9v11.175a1.675 1.675 0 0 0 1.864 1.85h27.758a1.692 1.692 0 0 0 1.877-1.874V8.271H2.494zM4.245 2.494c-.061 0-.121 0-.182.005A1.642 1.642 0 0 0 2.5 4.039c-.02.343-.016.678-.01 1.033v.665h31.5V4.445a1.712 1.712 0 0 0-1.944-1.95H4.245",
    style: {
      fill: "url(#j409hkrxka)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 152",
    d: "m52.091 123.845.6-.6c1.106-1.106 2.25-2.251 3.387-3.378a.349.349 0 0 1 .207-.079q1.681-.006 3.363-.006h3.185a.326.326 0 0 1 .184.051 982.273 982.273 0 0 1 3.682 3.689l.348.349-7.463 7.464zm7.486-1.571h-2.072a.645.645 0 0 0-.425.135c-.352.33-.7.67-1.031 1l-.453.444 3.957 3.956 3.954-3.952-.446-.445c-.331-.33-.673-.672-1.022-1.006a.609.609 0 0 0-.428-.131h-2.033",
    transform: "translate(-47.079 -108.257)",
    style: {
      fill: "url(#j409hkrxka)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    transform: "translate(22.777 12.982)",
    style: {
      fill: "url(#j409hkrxka)"
    },
    d: "M0 0h8.209v2.452H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    transform: "translate(22.785 18.742)",
    style: {
      fill: "url(#j409hkrxka)"
    },
    d: "M0 0h8.209v2.45H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHomeBundle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-homeBundle.e3cf8d91aa75c7dbe18927613ea37674.svg";